// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3VpVD","label":"Radio_label__3o0Zl","checkMark":"Radio_checkMark__2yDxv","disabled":"Radio_disabled__3zsAT"};